import script from "./summary_two.vue?vue&type=script&setup=true&lang=js"
export * from "./summary_two.vue?vue&type=script&setup=true&lang=js"

import "./summary_two.vue?vue&type=style&index=0&id=2522c54c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2522c54c"]])

export default __exports__